import { Component, effect, inject } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { Activity } from 'src/app/trip-calculator/models/activity';
import { PrestationModalService } from 'src/app/trip-calculator/services/prestation-modal.service';
import { PrestationEmptyStateComponent } from '../prestation-empty-state/prestation-empty-state.component';
import { TripService } from 'src/app/trip-calculator/services/trip.service';
import { ConfirmationService } from 'primeng/api';
import { PopoverModule } from 'primeng/popover';
import { SectionValidationService } from '../../../services/section-validation.service';
import { ItemValidationBadgeComponent } from '../../item-validation-badge/item-validation-badge.component';
import { DurationFormatPipe } from 'src/app/pipes/duration-format.pipe';

@Component({
  selector: 'app-activity-section',
  imports: [
    ButtonModule,
    TranslocoPipe,
    PrestationEmptyStateComponent,
    PopoverModule,
    ItemValidationBadgeComponent,
    DurationFormatPipe,
  ],
  templateUrl: './activity-section.component.html',
})
export class ActivitySectionComponent {
  tripService = inject(TripService);
  prestationModalService = inject(PrestationModalService);
  translocoService = inject(TranslocoService);
  confirmationService = inject(ConfirmationService);
  sectionValidationService = inject(SectionValidationService);
  activities?: Activity[];
  hasActivity: boolean = false;

  constructor() {
    effect(() => {
      const trip = this.tripService.trip();
      if (trip) {
        this.activities = trip.activities;
        this.hasActivity = trip.activities.length > 0;
      }
    });
  }
  addActivity = () => {
    this.prestationModalService.addActivity();
  };
  editActivity(index: number) {
    this.prestationModalService.editActivity(index);
  }
  deleteActivity(index: number) {
    this.tripService.deleteActivity(index)?.subscribe();
  }
  confirmDelete(index: number) {
    const message = this.translocoService.translate(
      'confirmation.deleteActivity',
    );
    const header = this.translocoService.translate(
      'confirmation.deleteConfirmation',
    );
    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translocoService.translate('yes'),
      rejectLabel: this.translocoService.translate('no'),
      accept: () => this.deleteActivity(index),
    });
  }

  onItemValidationBadgeClick(event: {
    scope: 'transport' | 'accommodation' | 'activity' | 'meal';
    index: number;
  }) {
    if (event.scope === 'activity') {
      this.prestationModalService.editActivity(event.index);
    }
  }

  hasDays(activity: Activity) {
    return activity.days && activity.days > 0;
  }
  hasHours(activity: Activity) {
    return activity.hours && activity.hours > 0;
  }
  hasDistance(activity: Activity) {
    return activity.kilometers && activity.kilometers > 0;
  }
}
